import { t } from '../../../locale';
import { FlowInterface } from '../plans/flow-interface';
import { generateBuyLink, generatePlanCategory } from '../helper/utils';

export default class BuyTrial extends FlowInterface {
  getCurrentParams() {
    return {
      ...this.getBuyNowParams(),
      plan: this.planType,
      from: generatePlanCategory(this.planType, this.capacity),
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.buy'),
    };
  }
}
